import { useEffect, useMemo, useState } from "react";
import LorsHero from "@/components/landing/lors/LorsHero";
import LorsTestimonials from "@/components/landing/lors/LorsTestimonials";
import LorsAbout from "@/components/landing/lors/LorsAbout";
import LorsRegistration from "@/components/landing/lors/LorsRegistration";
import LorsFooter from "@/components/landing/lors/LorsFooter";
import LorsStickyCta from "@/components/landing/lors/LorsStickyCta";
import { detectLang, type Lang } from "@/components/landing/lors/translations";
import { lorsContentJuly16 } from "@/components/landing/lors/translationsJuly16";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

const REDIRECT_TO = "/july-16-2026/ty";

const July162026 = () => {
  const [lang, setLang] = useState<Lang>("en");

  useEffect(() => {
    captureUtmsFromUrl();
    setLang(detectLang());
  }, []);

  useEffect(() => {
    const prev = document.documentElement.lang;
    document.documentElement.lang = lang;
    return () => {
      document.documentElement.lang = prev;
    };
  }, [lang]);

  const copy = useMemo(() => lorsContentJuly16[lang], [lang]);

  return (
    <main className="lors-theme">
      <div className="flex justify-end max-w-[1200px] mx-auto px-6 pt-3 text-xs">
        <button
          onClick={() => setLang("en")}
          className={`px-2 py-1 rounded ${lang === "en" ? "font-bold underline" : "opacity-70"}`}
          aria-pressed={lang === "en"}
        >
          EN
        </button>
        <span className="opacity-40 px-1">/</span>
        <button
          onClick={() => setLang("es")}
          className={`px-2 py-1 rounded ${lang === "es" ? "font-bold underline" : "opacity-70"}`}
          aria-pressed={lang === "es"}
        >
          ES
        </button>
      </div>
      <LorsHero copy={copy} redirectTo={REDIRECT_TO} formKey="july16" />
      <LorsTestimonials copy={copy} lang={lang} />
      <LorsAbout copy={copy} />
      <LorsRegistration copy={copy} />
      <LorsFooter copy={copy} />
      <LorsStickyCta copy={copy} />
    </main>
  );
};

export default July162026;
